import { ecboClient } from 'lib/axios'

import type { PlacesAutocompleteResponse } from 'features/places/types/placesAutocomplete'

const API_PLACES_AUTOCOMPLETE = '/api/web/places/autocomplete'

export const fetchPlacesAutocomplete = async (input: string, accessToken?: string) => {
  const response = await ecboClient.get<PlacesAutocompleteResponse>(API_PLACES_AUTOCOMPLETE, {
    params: {
      input,
      platform: 'web',
    },
    headers: accessToken ? { Authorization: `Token ${accessToken}` } : undefined,
  })

  return response.data
}
